import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../lib/auth-context.js'

/**
 * 管理者専用ルートのガード。`app_metadata.is_admin === true` のユーザーのみ通す。
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-sm text-muted-foreground">読み込み中...</p>
      </div>
    )
  }

  const isAdmin = (session?.user.app_metadata as { is_admin?: boolean } | undefined)?.is_admin
  if (!session || !isAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
